<template>
  <div class="sala_main" >
    <span class="home">
      <a href="#" class="btn btn-outline-success btn-sm" @click.prevent="home">Home</a>
    </span>
    <div class="sala">
    <div class="crea-sala text" >
      <div class="text" id="crea" @click="showOptions">{{ $t('crea_sala') }}</div>
      <div v-if="page == 'crea'" class="form">
        <span>{{ $t('inserisci_numero_tavoli') }}</span>
        <input type="number" :placeholder="$t('inserisci_numero_tavoli')" v-model="numero"/>
        <span>{{ $t('inserisci_nome_sala') }}</span>
        <input type="text" :placeholder="$t('inserisci_nome_sala')" v-model="nome" />
        <button @click="getSala">{{ $t('crea_sala') }}</button>
      </div>
    </div>
    <div class="sale text" v-for="sala in sale" :key="sala.nome" >
      <span class="entry" @click="goToSala(sala.nome,sala.numero)">{{sala.nome}}</span>
      <div class="del">
        <span class="tooltiptext" @click="()=>deleteSala(sala.nome)">{{ $t('elimina_sala') }}</span>
      </div>
      
      </div>
    </div>
  </div>
</template>

<script>
import { store } from '../store/store.js'
export default {
  name: 'Sala',
    props: {
    token: String,
  },
  data: function () {
    return {
        page:'',
        nome:'',
        numero:'',
        sale:[],
        numeroSale:[],
        nomeSale:[],
        store

    }
  },
    methods: {
      showOptions (e) {
        this.page = e.target.id == this.page? '': e.target.id;
      },
      home() {
        this.$router.push({ name: "Gestionale"})
      },
      getSala() {
        this.axios.post(this.store.path+'createSala',{nome:this.nome, numero:this.numero,headers:{
      authorization: `Bearer  ${JSON.parse(localStorage.token)}`}}).then((response) => {
          // axios.defaults.headers.common['Authorization'] = 'Bearer ' + r.data.token;
          //localStorage.setItem( 'token', JSON.stringify(response.data.token) );
          //this.$router.push({ name: "Gestionale", params :{data:`Ben Tornato ${this.nomeUtente}`,token: response.data.token} })
          if(response.data){
              console.log('Sale Salvata correttamente')
              this.displaySala();
              this.page = '';
              this.nome = '';
              this.numero = '';
          }else{console.log('Non è stato possibile Creare la sala')}
        })
      },
      displaySala() {
        this.axios.post(this.store.path+'displaySala',{headers:{
      authorization: `Bearer  ${JSON.parse(localStorage.token)}`}}).then((response) => {
          // carico le sale e le mostro 
          // axios.defaults.headers.common['Authorization'] = 'Bearer ' + r.data.token;
          //localStorage.setItem( 'token', JSON.stringify(response.data.token) );
          //this.$router.push({ name: "Gestionale", params :{data:`Ben Tornato ${this.nomeUtente}`,token: response.data.token} })
          var rv =[];
          var rvnome =[];
          var rvnumero = [];
          if(response.data.messaggio){
            console.log('Le Sale sono state caricate correttamente')
            response.data.messaggio.forEach(element => {
              rv.push(element);
              rvnome.push(element.nome);
              rvnumero.push(element.numero)
            });
            this.sale = rv;
            this.nomeSale= rvnome;
            this.numeroSale = rvnumero;
          }else{console.log('Non è stato possibile caricare le sale')}
        })
      },
      goToSala(sala,numero) {
        console.log(sala,numero)
        this.$router.push({ name: "VisualizzaSala", params :{nome:sala,numero:numero, sale:this.nomeSale, numeroSale:this.numeroSale} })
      },
      async deleteSala (sala) {
        if (confirm(`${this.$t('elimina_sala')} ${sala}?`)) {
          try {
            const settingsId = '69c90e57851daafaf559b837';
            const responseSettings = await this.axios.get(this.store.path + 'impostazioni/' + settingsId, {
                headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
            });
            if (responseSettings.data && responseSettings.data.passwordAdmin) {
                const passwordAdmin = responseSettings.data.passwordAdmin;
                const input = prompt("Inserisci la password amministratore per eliminare la sala:");
                if (input !== passwordAdmin) {
                    alert("Password amministratore errata!");
                    return;
                }
            }
          } catch (err) {
            console.error("Errore verifica password admin:", err);
          }

          this.axios.post(this.store.path+'deleteSala',{sala:sala,headers:{
        authorization: `Bearer  ${JSON.parse(localStorage.token)}`}}).then((response) => {
            if(response.data.messaggio){
              console.log('Le Sala è stata Eliminata')
              this.displaySala();
            }else{console.log('Non è stato possibile caricare le sale')}
          })
        }
      }
  },
  beforeMount() {
    this.displaySala();
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.home {
  margin-bottom: 20px;
}
.crea-sala {
  margin-bottom: 20px;
}
.sala_main {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  height: 100%;
}
.sala {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  height: 100%;
  flex-wrap: wrap;

}

.text {
  color:rgb(0, 0, 0);
  width: 35vw;
  align-self: center;
  
}

.form {
  display: flex;
  flex-direction: column;
  gap: 15px;
  justify-content: space-evenly;
}

.sale {
  display: flex;
  flex-direction: column;
  gap: 20px;
   /*height: 7vw;*/
    border-radius: 15px;
    background: #e0e0e0;
    box-shadow:  -19px 19px 38px #868686,
             19px -19px 38px #ffffff;
    width: 400px;
    height: 90px;
}
.del:hover .tooltiptext {
  visibility: visible;
}
.tooltiptext {
  /*visibility: hidden;
  width: 120px;*/
  color: rgb(0, 0, 0);
  /*text-align: center;
  border-radius: 6px;
  padding: 5px 0;*/
  cursor: url("../assets/del.png"), auto;

  /* Position the tooltip */
 
  z-index: 1;
}
.entry {
  cursor: pointer;
}

#crea {
  cursor: pointer;
}


</style>